"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC2771Type = exports.EIP712_CALL_WITH_SYNC_FEE_CONCURRENT_ERC2771_TYPE_DATA = exports.EIP712_SPONSORED_CALL_CONCURRENT_ERC2771_TYPE_DATA = exports.EIP712_CALL_WITH_SYNC_FEE_ERC2771_TYPE_DATA = exports.EIP712_SPONSORED_CALL_ERC2771_TYPE_DATA = void 0;
exports.EIP712_SPONSORED_CALL_ERC2771_TYPE_DATA = {
    SponsoredCallERC2771: [
        { name: "chainId", type: "uint256" },
        { name: "target", type: "address" },
        { name: "data", type: "bytes" },
        { name: "user", type: "address" },
        { name: "userNonce", type: "uint256" },
        { name: "userDeadline", type: "uint256" },
    ],
};
exports.EIP712_CALL_WITH_SYNC_FEE_ERC2771_TYPE_DATA = {
    CallWithSyncFeeERC2771: [
        { name: "chainId", type: "uint256" },
        { name: "target", type: "address" },
        { name: "data", type: "bytes" },
        { name: "user", type: "address" },
        { name: "userNonce", type: "uint256" },
        { name: "userDeadline", type: "uint256" },
    ],
};
exports.EIP712_SPONSORED_CALL_CONCURRENT_ERC2771_TYPE_DATA = {
    SponsoredCallConcurrentERC2771: [
        { name: "chainId", type: "uint256" },
        { name: "target", type: "address" },
        { name: "data", type: "bytes" },
        { name: "user", type: "address" },
        { name: "userSalt", type: "bytes32" },
        { name: "userDeadline", type: "uint256" },
    ],
};
exports.EIP712_CALL_WITH_SYNC_FEE_CONCURRENT_ERC2771_TYPE_DATA = {
    CallWithSyncFeeConcurrentERC2771: [
        { name: "chainId", type: "uint256" },
        { name: "target", type: "address" },
        { name: "data", type: "bytes" },
        { name: "user", type: "address" },
        { name: "userSalt", type: "bytes32" },
        { name: "userDeadline", type: "uint256" },
    ],
};
var ERC2771Type;
(function (ERC2771Type) {
    ERC2771Type["CallWithSyncFee"] = "CallWithSyncFee";
    ERC2771Type["SponsoredCall"] = "SponsoredCall";
    ERC2771Type["ConcurrentCallWithSyncFee"] = "ConcurrentCallWithSyncFee";
    ERC2771Type["ConcurrentSponsoredCall"] = "ConcurrentSponsoredCall";
})(ERC2771Type = exports.ERC2771Type || (exports.ERC2771Type = {}));
